import React from "react";
import { CButton } from "../UI";

import "./style.scss";

const ConfirmationModal = ({$locale, title, onClose}) => {
    const className = "confirmation-modal";

    return (
        <div className={className}>
            <div
                className={`${className}--title`}
                onClick={(e) => e.stopPropagation()}
            >
                {$locale.get(title)}
            </div>
            <div className={`${className}--buttons`}>
                <CButton
                    size="lg"
                    label={$locale.get('confirmation.leave')}
                    onClick={() => onClose({isConfirmed: true})}
                />
                <CButton
                    size="lg"
                    theme="accent"
                    label={$locale.get('confirmation.stay')}
                    onClick={() => onClose({isConfirmed: false})}
                />
            </div>
        </div>
    );
};

export default ConfirmationModal;
